import { SearchInput, Label, type OnChange } from "@tokenterminal/ui/InputV3"
import { useCallback, useEffect, useRef } from "react"
import { type TextFilterId, useTextFilter } from "./asideTextFilterHooks"

interface TextFilterProps {
  id: TextFilterId
  autoFocus?: boolean
}

export const TextFilter = ({ id, autoFocus }: TextFilterProps) => {
  const [value, setValue] = useTextFilter(id)
  const inputRef = useRef<HTMLInputElement>(null)

  const onChange: OnChange = useCallback(
    ({ target }) => {
      setValue(target.value)
    },
    [setValue]
  )

  useEffect(() => {
    let rAF: number | undefined
    if (autoFocus) {
      rAF = requestAnimationFrame(() => {
        // Dont autofocus in mobile because it pops up keyboard and use has no context on what's happening
        if (window.innerWidth > 768) {
          inputRef.current?.focus()
        }
      })
    }
    return () => {
      if (rAF) {
        cancelAnimationFrame(rAF)
      }
    }
  }, [autoFocus])

  return (
    <Label width="100%">
      <SearchInput
        value={value}
        onChange={onChange}
        placeholder="Search"
        ref={inputRef}
      />
    </Label>
  )
}
